import {
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/components/ui/form';
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from '@/components/ui/tooltip';

import { Slider } from '@/components/ui/slider';
import _ from 'lodash';
import { Info } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

interface SliderInputProps {
	name: string;
	label?: string;
	description?: string;
	min?: number;
	max?: number;
	step?: number;
	tooltip?: string;
	symbol?: {
		prefix?: string;
		suffix?: string;
	};
}

export function GroupPricingSlider(props: SliderInputProps) {
	const form = useFormContext();

	const {
		name,
		label,
		description,
		max,
		step = 1,
		symbol,
		min = 0,
		tooltip,
	} = props;

	return (
		<div className='tw-space-y-2'>
			<FormField
				control={form.control}
				name={name}
				render={({ field }) => (
					<FormItem>
						<FormLabel>
							{label ?? _.startCase(field.name)}{' '}
							{tooltip && (
								<TooltipProvider delayDuration={300}>
									<Tooltip>
										<TooltipTrigger asChild>
											<Info className='tw-inline tw-h-3.5 tw-w-3.5 tw-mb-1 tw-text-gray-400 tw-cursor-pointer' />
										</TooltipTrigger>
										<TooltipContent
											side='right'
											className='tw-max-w-xs tw-bg-white !tw-text-black tw-border tw-border-gray-200 tw-shadow-md tw-rounded tw-px-3 tw-py-2 tw-text-sm'
										>
											{tooltip}
										</TooltipContent>
									</Tooltip>
								</TooltipProvider>
							)}
							<span className='tw-text-destructive tw-ml-2'>
								{symbol?.prefix}
								{field.value}
								{symbol?.suffix}
							</span>
						</FormLabel>
						<FormControl>
							<Slider
								value={[field.value]}
								onValueChange={(newValue) => field.onChange(newValue[0])}
								max={max}
								min={min}
								step={step}
							/>
						</FormControl>
						<FormDescription>{description}</FormDescription>
						<FormMessage />
					</FormItem>
				)}
			/>
		</div>
	);
}
